import { QuestionTypes } from 'enum'
import api from '../..'

export interface IAnswerLikertCreateRequest {
  questionsLikertLabelId: number
  answerAttributes: { blockInstanceId: number; questionId: number }
}

export interface IAnswerLikertCreateResponse {
  id: number
  answer: Answer
  createdAt: string
  questionsLikertLabelId: number
  updatedAt: string
}

export interface Answer {
  id: number
  answerableType: QuestionTypes.likert
  answerableId: number
  blockInstanceId: number
  questionId: number
  enrolId: number
  createdAt: string
  updatedAt: string
}

const answerLikertCreate = (answerLikert: IAnswerLikertCreateRequest) => {
  return api
    .post<{
      data: {
        attributes: IAnswerLikertCreateResponse
      }
    }>('answers/likerts', answerLikert)
    .then((res) => res.data.data.attributes)
}

export default answerLikertCreate
